
import { usePatientProfileWidget } from '../../../../hooks/use-patient-profile-widget';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import Scrollbars from 'react-custom-scrollbars-2';
import { WidgetRoutePath } from '../../../../navigation/route-config';
import { Body, CancelButton, Footer, WidgetContainer } from './preferences-view-wrapper.styles';

export interface IProps {
  headerSubText?: string;
  onSave: () => Promise<void>;
  children: React.ReactNode;
}

export const PreferencesViewWrapper: React.FC<IProps> = props => {
  const { goTo } = usePatientProfileWidget();
  const [isLoading, setIsLoading] = useState(false);

  const handleSave = async () => {
    setIsLoading(true);
    await props.onSave();
    setIsLoading(false);
  }

  return (
    <WidgetContainer>
      <Scrollbars autoHide style={{ flexGrow: 1 }}>
        <Body>
          {props.children}
        </Body>
      </Scrollbars>
      <Footer>
        <CancelButton
          variant='contained'
          onClick={() => goTo(WidgetRoutePath.COMM_PREFERENCES)}
          disableElevation>
          Cancel
        </CancelButton>
        <LoadingButton
          variant='contained'
          loading={isLoading}
          onClick={handleSave}
          disableElevation
          sx={{
            width: '132px',
            fontFamily: 'Roboto',
            fontStyle: 'normal',
            fontWeight: '500',
            fontSize: '14px',
            lineHeight: '24px'
          }}>
          Save
        </LoadingButton>
      </Footer>
    </WidgetContainer>
  );
};
